import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import Landing from "./pages/Landing";
import ASZFPage from "./pages/ASZFPage";
import AdatvedelemPage from "./pages/AdatvedelemPage";
import NotFoundPage from "./pages/NotFoundPage";
import "./App.css";

export default function App() {
    return (
        <div className="App">
            <HelmetProvider>
                <BrowserRouter>
                    <Routes>
                        <Route path="/" element={<Landing />} />
                        <Route path="/aszf" element={<ASZFPage />} />
                        <Route path="/adatvedelem" element={<AdatvedelemPage />} />
                        <Route path="*" element={<NotFoundPage />} />
                    </Routes>
                </BrowserRouter>
            </HelmetProvider>
        </div>
    );
}
